import { render, staticRenderFns } from "./ApplicantList.vue?vue&type=template&id=0bd629f8&"
import script from "../../../services/admin/applicant/applicant-list.js?vue&type=script&lang=js&"
export * from "../../../services/admin/applicant/applicant-list.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports